__turbopack_context__.v({
  "langOption": "OptionLang-module__DSL_nW__langOption",
  "localeWrapper": "OptionLang-module__DSL_nW__localeWrapper",
  "selected": "OptionLang-module__DSL_nW__selected",
  "selectedIcon": "OptionLang-module__DSL_nW__selectedIcon",
});
